// see more @ https://flatpickr.js.org/localization/

import flatpickr from 'flatpickr'
import { Portuguese } from 'flatpickr/dist/l10n/pt'

flatpickr.localize(Portuguese) // default locale is now Russian

